import type {
  QuestionnaireDefinition,
  QuestionnaireOption,
} from "@/conversation/QuestionnaireTypes";

// TEMP: Local definitions for exercising the renderer from the development test popover.
export type QuestionnaireOptionFixture = QuestionnaireOption & {
  weight: number;
};
export type QuestionnaireQuestionFixture =
  QuestionnaireDefinition["questions"][number];
export type QuestionnaireDefinitionFixture = QuestionnaireDefinition;

const frequencyOptions: QuestionnaireOptionFixture[] = [
  { value: "0", label: "Not at all", weight: 0 },
  { value: "1", label: "Several days", weight: 1 },
  { value: "2", label: "More than half the days", weight: 2 },
  { value: "3", label: "Nearly every day", weight: 3 },
];

export const questionnaireDefinitionFixtures: QuestionnaireDefinitionFixture[] =
  [
    {
      id: "curai-gad-7",
      title: "GAD-7",
      description:
        "Over the last 2 weeks, how often have you been bothered by the following problems?",
      completionMessage:
        "Thanks. Your care team will review your answers before the visit.",
      questions: [
        "Feeling nervous, anxious, or on edge",
        "Not being able to stop or control worrying",
        "Worrying too much about different things",
        "Trouble relaxing",
        "Being so restless that it is hard to sit still",
        "Becoming easily annoyed or irritable",
        "Feeling afraid as if something awful might happen",
      ].map((text, index) => ({
        id: `q${index + 1}`,
        text,
        required: true,
        options: frequencyOptions,
      })),
    },
    {
      id: "curai-phq-9",
      title: "PHQ-9",
      description:
        "Over the last 2 weeks, how often have you been bothered by the following problems?",
      completionMessage:
        "Thanks. Your care team will review your answers before the visit.",
      questions: [
        "Little interest or pleasure in doing things",
        "Feeling down, depressed, or hopeless",
        "Trouble falling or staying asleep, or sleeping too much",
        "Feeling tired or having little energy",
        "Poor appetite or overeating",
        "Feeling bad about yourself - or that you are a failure or have let yourself or your family down",
        "Trouble concentrating on things, such as reading the newspaper or watching television",
        "Moving or speaking so slowly that other people could have noticed, or the opposite - being so fidgety or restless that you have been moving around a lot more than usual",
        "Thoughts that you would be better off dead, or of hurting yourself in some way",
      ].map((text, index) => ({
        id: `q${index + 1}`,
        text,
        required: true,
        options: frequencyOptions,
      })),
    },
  ];
